import { LOG_IN, LOG_OUT, RELOAD_TIME } from "../types";
import IAuth from "../../interfaces/IAuth";

export const login = (payload: IAuth) => ({type: LOG_IN, payload});
export const logout = () => ({type: LOG_OUT});
export const extendSesion = () => ({type: RELOAD_TIME})